module.exports = __webpack_public_path__ + "static/img/vivo-logo.f051745f.png";